import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { ChcpRoute } from '@cigna/chcp/shared/util';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { map, Observable, of } from 'rxjs';
import { ChcpLaunchDarklyFlagKey } from '@cigna/chcp/shared/launch-darkly-util';

@Injectable()
export class FeatureToggleGuard {
  constructor(
    private featureTogglesFacade: FeatureTogglesFacade,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const features = (route as ChcpRoute).data?.guards?.features;

    if (!features) {
      return of(true);
    }

    return this.featureTogglesFacade
      .featuresEnabled<ChcpLaunchDarklyFlagKey>(features, 'OR')
      .pipe(
        map((res: boolean) => {
          if (!res) {
            return this.router.parseUrl('/dashboard');
          }
          return true;
        }),
      );
  }
}
